import { Logger } from '@/utils/logging';

import type { TrackingInterface } from '../_types';
import { BOOK_APPOINTMENT_EVENT } from '../trackingConstants';
import { buildGaBookAppointmentPayload } from './buildGaBookAppointmentPayload';
import { syncGaScriptTags } from './syncGaScriptTags';

import './googleAnalyticsTracker.types';

export const googleAnalyticsTracker = (): TrackingInterface => ({
  setUserId: () => {},
  track: (message, context) => {
    if (message !== BOOK_APPOINTMENT_EVENT) return;
    if (typeof window === 'undefined') return;
    // A BNPL return can fire before CustomAnalytics injects the brand's tag.
    const shopGaId = context?.shopGaMeasurementId;
    if (typeof shopGaId === 'string' && shopGaId) syncGaScriptTags(shopGaId);
    if (typeof window.squireCustomBrandGaGtag !== 'function') {
      Logger.console('[ga-tracker] gtag not loaded; skipping book_appointment');
      return;
    }
    const payload = buildGaBookAppointmentPayload(context);
    if (!payload) {
      Logger.error(
        '[ga-tracker] missing saleOrderId; skipping book_appointment',
      );
      return;
    }
    window.squireCustomBrandGaGtag('event', BOOK_APPOINTMENT_EVENT, payload);
  },
});
